import React from 'react';
import ProfessionalServicesSlider from './ProfessionalServicesSlider';

import ProfessionalServicesAnimation from './ProfessionalServicesAnimation';

const ProfessionalServices = () => {
  return (
    <div className="relative bg-[#F5F5F5] pb-[60px] overflow-hidden">
      <ProfessionalServicesAnimation />
      <div className="container pt-48 py-[30px] md:pr-20px pr-0">
        <div className="relative">
          <div className="flex justify-center flex-col items-center w-full relative z-20 gap-[20px]">
            <h2 className="font-[600] text-[32px] md:text-[34px] leading-[39px] md:leading-[42px] text-black px-[8px]">
              Our Guaranteed Full SEO Services
            </h2>
            <ProfessionalServicesSlider />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfessionalServices;
